import React, { FC } from 'react';

interface BadgeProps {
    className?: string;
    children: any;
    bgColor?: string;
    fgColor?: string;
}

const Badge: FC<BadgeProps> = ({ children, className = '', bgColor = 'bg-orange-badge', fgColor = 'text-white'}) => {
    return (
        <span id='TabTotalRecordCount' className={`text-xs font-semibold px-2 py-0 rounded ${bgColor} ${fgColor} ${className}`}>
            {children}
        </span>
    );
}

export default Badge;
